// components/widgets/primitives/toolbar.js
// ═══════════════════════════════════════════════════════════
// WIDGET TOOLBAR — small action button row inside a widget body.
// Most common use: a regenerate / refresh button + inline meta.
//
// (When widgets refactor to expose `footerActions`, the toolbar
// pattern can deprecate in favor of the card footer. Until then,
// inline toolbar handles the gap.)
// ═══════════════════════════════════════════════════════════

export function Toolbar({ children, className = '' }) {
  return <div className={`ws-prim-toolbar ${className}`}>{children}</div>;
}

export function ToolbarButton({ onClick, disabled, children, title, className = '' }) {
  return (
    <button
      type="button"
      className={`ws-prim-toolbar-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {children}
    </button>
  );
}

export function ToolbarMeta({ children, className = '' }) {
  if (!children) return null;
  return <span className={`ws-prim-toolbar-meta ${className}`}>{children}</span>;
}

export default Toolbar;
